import http from '../utils/http'
//
/**
 *  @parms resquest 请求地址 例如：http://197.82.15.15:8088/request/...
 *  @param '/testIp'代表vue-cil中config，index.js中配置的代理
 */
const DEBUG = false // 开发环境为true 生产环境为false

let resquest = DEBUG ? 'https://dev.finsen.scrm.essesuit.com' : 'https://api.work.finsen.com.cn'
// let resquest ="https://dev.finsen.scrm.essesuit.com";//测试地址
// let resquest="https://finsen.scrm.essesuit.com";//正式地址

// 退出登陆
export function version(params){
    return http.post(`${resquest}/api/system/getVersion`,params)
}
// 退出登陆
export function pdd(params){
    return http.post(`${resquest}/api/pdd/test`,params)
}
// post请求 登陆
export function requestLogin(params){
    return http.post(`${resquest}/api/user/login`,params)
}
// 退出登陆
export function loginOut(params){
    return http.post(`${resquest}/api/user/loginOut`,params)
}
// 获取登陆用户的所有权限
export function loginUserPermissions(params){
    return http.post(`${resquest}/api/user/loginUserPermissions`,params)
}
// 获取当前用户排班/打卡情况
export function userWorkInfo(params){
    return http.post(`${resquest}/api/user/getUserWorkInfo`,params)
}
// 获取登陆用户的任务金额
export function userVerify(params){
    return http.post(`${resquest}/api/user/verify`,params)
}
/*********************** 栏目管理 ****************************** */
// 栏目列表
// export function menuList(params){
//     return http.post(`${resquest}/api/permission/index`,params)
// }
export function getmenulist(params){
    return http.post(`${resquest}/api/permission/index`,params)
}
//新增栏目
export function permissioncreate(params){
    return http.post(`${resquest}/api/permission/create`,params)
}
//修改栏目
export function permissionedit(params){
    return http.post(`${resquest}/api/permission/edit`,params)
}
//超级密码
export function getSuperPass(params){
    return http.post(`${resquest}/api/user/getSuperPass`,params)
}

/*********************** 部门管理 ****************************** */
//部门列表
export function departmentList(params){
    return http.post(`${resquest}/api/department/index`,params)
}
//新增部门
export function departmentcreate(params){
    return http.post(`${resquest}/api/department/create`,params)
}
//修改部门
export function departmentedit(params){
    return http.post(`${resquest}/api/department/edit`,params)
}
/*********************** 角色管理 ****************************** */
// 功能权限
export function permissions(params){
    return http.post(`${resquest}/api/role/permissions`,params)
}
// 角色列表
export function roleList(params){
    return http.post(`${resquest}/api/role/index`,params)
}
// 角色列表无分页
export function roleListNoPage(params){
    return http.post(`${resquest}/api/role/listNoPage`,params)
}
// 新增角色
export function rolecreate(params){
    return http.post(`${resquest}/api/role/create`,params)
}
// 修改角色
export function roleedit(params){
    return http.post(`${resquest}/api/role/edit`,params)
}
/*********************** 用户管理 ****************************** */
// 用户列表
export function userList(params){
    return http.post(`${resquest}/api/user/index`,params)
}
// 用户列表无分页
export function userListNoPage(params){
    return http.post(`${resquest}/api/user/listNoPage`,params)
}
// // 用户列表无分页
// export function userListNoPage(params){
//     return http.post(`${resquest}/api/user/listNoPageNew`,params)
// }
// 新建用户
export function usercreate(params){
    return http.post(`${resquest}/api/user/create`,params)
}
// 修改用户
export function useredit(params){
    return http.post(`${resquest}/api/user/edit`,params)
}
// 添加数据权限
export function dataAuth(params){
    return http.post(`${resquest}/api/user/dataAuth`,params)
}
// 获取用户数据权限
export function dataAuthDel(params){
    return http.post(`${resquest}/api/user/getDataAuth`,params)
}
// 企业微信列表
export function weComList(params){
    return http.post(`${resquest}/api/user/weComList`,params)
}
// 企业微信授权
export function bindWeCom(params){
    return http.post(`${resquest}/api/user/bindWeCom`,params)
}
// 企业微信解除授权
export function removeBind(params){
    return http.post(`${resquest}/api/user/removeBind`,params)
}
// 同步天润
export function synTrUser(params){
    return http.post(`${resquest}/api/user/synTrUser`,params)
}
// 用户状态
export function userstatus(params){
    return http.post(`${resquest}/api/user/status`,params)
}
// 用户上班
export function workDate(params){
    return http.post(`${resquest}/api/user/workDate`,params)
}
// 客户关系转移
export function changeBond(params){
    return http.post(`${resquest}/api/user/changeBond`,params)
}
// 重置密码
export function resetPassword(params){
    return http.post(`${resquest}/api/user/resetPassword`,params)
}
// 修改密码
export function updatePassword(params){
    return http.post(`${resquest}/api/user/updatePassword`,params)
}
// 批量更换部门
export function changeDepartment(params){
    return http.post(`${resquest}/api/user/changeDepartment`,params)
}
// 验证码短信
export function sendCode(params){
    return http.post(`${resquest}/api/sms/sendCode`,params)
}
// 更新企业微信信息
export function syncWeComeInfo(params){
    return http.post(`${resquest}/api/user/syncWeComeInfo`,params)
}
// 修改用户所属软著
export function saveUserSoft(params){
    return http.post(`${resquest}/api/system/saveUserSoft`,params)
}
// 软著列表
export function softList(params){
    return http.post(`${resquest}/api/system/softList`,params)
}
// 软著详情
export function softInfo(params){
    return http.post(`${resquest}/api/system/softInfo`,params)
}

/*********************** 企业管理 ****************************** */
// 企业列表
export function companyList(params){
    return http.post(`${resquest}/api/company/index`,params)
}
// 企业增加
export function companyCreate(params){
    return http.post(`${resquest}/api/company/create`,params)
}
// 企业修改
export function companyUpdate(params){
    return http.post(`${resquest}/api/company/update`,params)
}
// 企业状态修改
export function companyStatus(params){
    return http.post(`${resquest}/api/company/delete`,params)
}
// 获取企业配置
export function companyConfig(params){
    return http.post(`${resquest}/api/company/companyConfig`,params)
}
// 添加企业申请
export function addExamineCompany(params){
    return http.post(`${resquest}/api/work/addExamineCompany`,params)
}
// 企业审批列表
export function examineCompany(params){
    return http.post(`${resquest}/api/work/examineCompany`,params)
}
// 企业审批详情
export function examineCompanyDel(params){
    return http.post(`${resquest}/api/work/getExamineCompany`,params)
}
// 企业审批流程撤回
export function recallExamineCompany(params){
    return http.post(`${resquest}/api/work/recallExamineCompany`,params)
}
// 企业审批流程节点操作
export function handleExamineCompany(params){
    return http.post(`${resquest}/api/work/handleExamineCompany`,params)
}

/*********************** 系统配置 ****************************** */
// 获取短信配置信息
export function smsConfig(params){
    return http.post(`${resquest}/api/adminConfig/smsConfig`,params)
}
// 修改短信配置
export function editSmsConfig(params){
    return http.post(`${resquest}/api/adminConfig/editSmsConfig`,params)
}
/*********************** 话务管理 ****************************** */
// 话务列表
export function trafficList(params){
    return http.post(`${resquest}/api/traffic/trafficList`,params)
}

export function isWaitToProcess(params){
    return http.post(`${resquest}/api/customer/isWaitToProcess`,params)
}
export function customerCallRecord(params){
    return http.post(`${resquest}/api/traffic/customerCallRecord`,params)
}
// 话务列表导出
export function trafficListDown(params){
    return http.post(`${resquest}/api/traffic/trafficListDown`,params)
}
// 拨打电话-黑名单或非白名单状态
export function trBlack(params){
    return http.post(`${resquest}/api/customer/trBlack`,params)
}

/*********************** 客户管理 ****************************** */
// 客户列表
export function customerList(params){
    return http.post(`${resquest}/api/customer/index`,params)
}
// 客户列表无分页
export function customerListNoPage(params){
    return http.post(`${resquest}/api/customer/listNoPage`,params)
}
// 新增客户
export function createCustomer(params){
    return http.post(`${resquest}/api/customer/create`,params)
}
// 编辑客户
export function createEdit(params){
    return http.post(`${resquest}/api/customer/edit`,params)
}
// 客户详情
export function customerDetail(params){
    return http.post(`${resquest}/api/customer/detail`,params)
}
// 修改客户手机号
export function saveCustomerPhone(params){
    return http.post(`${resquest}/api/customer/saveCustomerPhone`,params)
}
// 操作客户记录
export function customerHandleLog(params){
    return http.post(`${resquest}/api/customer/handleLog`,params)
}
// 客户通话统计
export function customerTrafficCount(params){
    return http.post(`${resquest}/api/customer/getCustomerTrafficCount`,params)
}
// 客户发短信
export function sendShortMessage(params){
    return http.post(`${resquest}/api/sms/send`,params)
}
// 短信模板
export function sendMessageList(params){
    return http.post(`${resquest}/api/sms/template`,params)
}
// 标签列表
export function tagList(params){
    return http.post(`${resquest}/api/customer/tagList`,params)
}
// 添加标签
export function addTag(params){
    return http.post(`${resquest}/api/customer/addTag`,params)
}
// 客户绑定标签
export function setTag(params){
    return http.post(`${resquest}/api/customer/setTag`,params)
}
// 公海列表
export function seaList(params){
    return http.post(`${resquest}/api/customer/seaList`,params)
}
// 公海客户领取
export function getSeaCustomer(params){
    return http.post(`${resquest}/api/customer/getSeaCustomer`,params)
}
// 公海客户绑定企微
export function customerbindWecom(params){
    return http.post(`${resquest}/api/customer/bindWecom`,params)
}
// 公海客户释放
export function unBind(params){
    return http.post(`${resquest}/api/customer/unBind`,params)
}
// 订单列表
export function orderList(params){
    return http.post(`${resquest}/api/customer/order`,params)
}
// 数据管理-出单客户
export function issueCustomer(params){
    return http.post(`${resquest}/api/customer/orderCustomer`,params)
}
// 订单分配
export function assignCustomer(params){
    return http.post(`${resquest}/api/customer/assignCustomer`,params)
}
// 订单分配到部门
export function assignToDepartment(params){
    return http.post(`${resquest}/api/customer/assignToDepartment`,params)
}
// 订单分配-部门列表
export function assignDepartmentList(params){
    return http.post(`${resquest}/api/customer/departmentList`,params)
}
// 转移客户
export function moveCustomer(params){
    return http.post(`${resquest}/api/customer/moveCustomer`,params)
}
// 下单商品列表
// export function getGoodsCouponList(params){
//     return http.post(`${resquest}/api/goods/getGoodsCouponList`,params)
// }
export function getGoodsCouponList(params){
    return http.post(`${resquest}/api/goods/getGoodsListNew`,params)
}
// 获取可用优惠券
// export function getCouponList(params){
//     return http.post(`${resquest}/api/goods/getCouponList`,params)
// }
export function couponListNo(params){
    return http.post(`${resquest}/api/goods/couponListNo`,params)
}
// 下单、生成订单
export function createOrder(params){
    return http.post(`${resquest}/api/goods/createOrder`,params)
}
// 生成订单支付二维码
export function getPayQRCode(params){
    return http.post(`${resquest}/api/goods/getPayQRCode`,params)
}
// 生成订单确认页二维码
export function getOrderInfoCode(params){
    return http.post(`${resquest}/api/orderH5/getOrderInfoCode`,params)
}
// 判断顺丰到付是否可达
export function orderIsReachSend(params){
    return http.post(`${resquest}/api/order/orderIsReachSend`,params)
}
// 获取订单支付状态
export function getOrderStatus(params){
    return http.post(`${resquest}/api/goods/getOrderStatus`,params)
}
// 客户通话备注
export function customerRemarks(params){
    return http.post(`${resquest}/api/customer/remarks`,params)
}
// 客户呼叫备注
export function callRemarks(params){
    return http.post(`${resquest}/api/trafficTags/callRemarks`,params)
}
// 客户呼叫备注-标签
export function trafficTags(params){
    return http.post(`${resquest}/api/trafficTags/index`,params)
}
// 客户呼叫备注-标签新增
export function addTrafficTags(params){
    return http.post(`${resquest}/api/trafficTags/create`,params)
}
// 客户呼叫备注-激励语、业绩
export function trafficInspiring(params){
    return http.post(`${resquest}/api/trafficInspiring/info`,params)
}
// 客户详情查看录音
export function callFile(params){
    return http.post(`${resquest}/api/traffic/callFile`,params)
}
// 我的订单
export function getMyOrder(params){
    return http.post(`${resquest}/api/customer/getMyOrder`,params)
}
// 我的订单-客户类型
export function customerTypeList(params){
    return http.post(`${resquest}/api/order/customerTypeList`,params)
}
// 我的订单-部门列表(组长级)
export function adminGroupList(params){
    return http.post(`${resquest}/api/order/adminGroupList`,params)
}
// 我的订单详情
// export function myOrderDetail(params){
//     return http.post(`${resquest}/api/customer/getMyOrderDetail`,params)
// }//弃用
export function myOrderDetail(params){
    return http.post(`${resquest}/api/order/getOrderInfo`,params)
}
//查询企微交易号信息
export function wecomPaySnInfo(params){
    return http.post(`${resquest}/api/order/getWecomPaySnInfo`,params)
}
//通过企微确认收款
export function setOrderPayStatus(params){
    return http.post(`${resquest}/api/order/setOrderPayStatus`,params)
}
// 我的订单详情（未付款重新生成订单二维码）
export function createOrderPayCode(params){
    return http.post(`${resquest}/api/customer/createOrderPayCode`,params)
}
// 我的订单详情（继续付款生成订单二维码）
export function orderStagesPay(params){
    return http.post(`${resquest}/api/customer/getOrderStagesPay`,params)
}
// 我的订单详情（财务修改订单完结）
export function orderConfirmClose(params){
    return http.post(`${resquest}/api/order/orderConfirmClose`,params)
}
// 我的订单详情（取消付款）
export function cancelOrderPay(params){
    return http.post(`${resquest}/api/customer/cancelOrderPay`,params)
}
// 我的订单详情 取消支付单<已支付修改未支付>
export function orderCancelPay(params){
    return http.post(`${resquest}/api/order/orderCancelPay`,params)
}
// 查看订单商品详情
export function getOrderGoodsInfo(params){
    return http.post(`${resquest}/api/order/getOrderGoodsInfo`,params)
}
// 查询退款订单详情
export function refundOrderInfo(params){
    return http.post(`${resquest}/api/order/refundOrderInfo`,params)
}
// 退款操作
export function refundOrder(params){
    return http.post(`${resquest}/api/order/refundOrder`,params)
}
export function applyOrderRefund(params){
    return http.post(`${resquest}/api/order/applyOrderRefund`,params)
}
// 我的订单导出
export function downMyOrder(params){
    return http.post(`${resquest}/api/customer/downMyOrder`,params)
}
// 我的订单导出(查询下载订单是否有权限)
export function isDownOrder(params){
    return http.post(`${resquest}/api/customer/isDownOrder`,params)
}
// 修改我的订单支付状态
export function setMyOrderStatus(params){
    return http.post(`${resquest}/api/customer/setMyOrderStatus`,params)
}
// 查询是否有权限修改订单状态
export function isSetMyOrderStatus(params){
    return http.post(`${resquest}/api/customer/isSetMyOrderStatus`,params)
}
// 查询旧订单信息
export function transferOrderPayInfo(params){
    return http.post(`${resquest}/api/order/getTransferOrderPayInfo`,params)
}
// 进行转单操作
export function orderTransferConfirm(params){
    return http.post(`${resquest}/api/order/orderTransferConfirm`,params)
}
// 修改发货信息
export function sendOrder(params){
    return http.post(`${resquest}/api/customer/sendOrder`,params)
}
// 销售修改订单备注
export function setOrderAdminRemark(params){
    return http.post(`${resquest}/api/customer/setOrderAdminRemark`,params)
}
// 我的微信客户
export function wechatCustomerList(params){
    return http.post(`${resquest}/api/customer/wechatCustomerList`,params)
}
// 退款申请列表
export function orderRefundList(params){
    return http.post(`${resquest}/api/order/orderRefundList`,params)
}
//退款申请列表 详情
export function orderRefundDetail(params){
    return http.post(`${resquest}/api/order/orderRefundDetail`,params)
}
//审核申请退款/货 操作
export function orderRefundHandle(params){
    return http.post(`${resquest}/api/order/orderRefundHandle`,params)
}
// 退款申请列表撤回
export function applyOrderRecall(params){
    return http.post(`${resquest}/api/order/applyOrderRecall`,params)
}
// 查看订单物流信息-（仅限顺丰到付）
export function orderExpressData(params){
    return http.post(`${resquest}/api/order/getOrderExpressData`,params)
}
//修改收货地址
export function orderUpAddress(params){
    return http.post(`${resquest}/api/order/orderUpAddress`,params)
}
//修改销售订单标签
export function saveOrdersellTag(params){
    return http.post(`${resquest}/api/order/saveOrderTag`,params)
}
//销售标签列表
export function selltagList(params){
    return http.post(`${resquest}/api/order/orderTagList`,params)
}
//数据脱敏
export function customerView(params){
    return http.post(`${resquest}/api/customer/customerView`,params)
}
//数据脱敏-不限制（仅限外呼）
export function customerPhoneView(params){
    return http.post(`${resquest}/api/customer/customerPhoneView`,params)
}
//查看销售查看脱敏数据
export function userCustomerView(params){
    return http.post(`${resquest}/api/user/getCustomerView`,params)
}
//修改销售查看脱敏额度-仅限当天
export function improveCustomerView(params){
    return http.post(`${resquest}/api/user/improveCustomerView`,params)
}
//客户黑名单列表
export function customerBlackList(params){
    return http.post(`${resquest}/api/customer/customerBlackList`,params)
}
//客户黑名单-查询客户信息
export function customerSearch(params){
    return http.post(`${resquest}/api/customer/customerSearch`,params)
}
//客户黑名单-添加客户为黑名单
export function addCustomerBlacklist(params){
    return http.post(`${resquest}/api/customer/addCustomerBlacklist`,params)
}
//客户黑名单-修改黑名单信息
export function saveCustomerBlacklist(params){
    return http.post(`${resquest}/api/customer/saveCustomerBlacklist`,params)
}
// 名片数据导出
export function downCardData(params){
    return http.post(`${resquest}/api/customer/downOrder`,params)
}
// 订单赠品审核列表
export function examineGift(params){
    return http.post(`${resquest}/api/work/examineGift`,params)
}
export function handleExamineGift(params){
    return http.post(`${resquest}/api/work/handleExamineGift`,params)
}
export function recallExamineGift(params){
    return http.post(`${resquest}/api/work/recallExamineGift`,params)
}
export function orderGiftDetail(params){
    return http.post(`${resquest}/api/work/getExamineGift`,params)
}
export function againOrderGift(params){
    return http.post(`${resquest}/api/order/againOrderGift`,params)
}
export function examineUser(params){
    return http.post(`${resquest}/api/work/getExamineUser`,params)
}
export function downExamineGift(params){
    return http.post(`${resquest}/api/work/downExamineGift`,params)
}



/*********************** 订单管理-包裹卡兑奖订单SCRM ****************************** */
// 包裹卡订单列表
export function packagePrizeOrderList(params){
    return http.post(`${resquest}/api/order/getPackagePrizeOrderList`,params)
}
// 包裹卡订单导出
export function downPackagePrizeOrder(params){
    return http.post(`${resquest}/api/order/downPackagePrizeOrder`,params)
}
// 查看订单脱敏数据
export function packagePrizeCustomerView(params){
    return http.post(`${resquest}/api/customer/packagePrizeCustomerView`,params)
}
// 添加包裹卡兑奖
export function addPackagePrize(params){
    return http.post(`${resquest}/api/order/addPackagePrize`,params)
}
// 验证原订单是否存在
export function packagePrizeBuyOid(params){
    return http.post(`${resquest}/api/order/getPackagePrizeBuyOid`,params)
}
// 获取包裹卡奖品列表
export function packagePrizeGoods(params){
    return http.post(`${resquest}/api/order/getPackagePrizeGoods`,params)
}
// 包裹卡兑奖-关联后链路订单
export function savePackagePrizeAdminOrder(params){
    return http.post(`${resquest}/api/order/savePackagePrizeAdminOrder`,params)
}
/*********************** 订单管理-包裹卡兑奖订单ERP ****************************** */
// 包裹卡兑奖列表-库房
export function storePackagePrizeOrderList(params){
    return http.post(`${resquest}/api/order/getStorePackagePrizeOrderList`,params)
}
// 包裹卡兑奖订单-发货
export function sendPackagePrize(params){
    return http.post(`${resquest}/api/order/sendPackagePrize`,params)
}
// 包裹卡兑奖订单-批量发货
export function batchSendPackagePrize(params){
    return http.post(`${resquest}/api/order/batchSendPackagePrize`,params)
}
// 包裹卡兑奖订单-发货-同步erp
export function sendPackagePrizeGoods(params){
    return http.post(`${resquest}/api/order/sendPackagePrizeGoods`,params)
}

/*********************** 数据管理-分配配置 ****************************** */
// 用户-分配配置
export function userAssignSlice(params){
    return http.post(`${resquest}/api/user/assignSlice`,params)
}
// 部门-分配配置
export function departAssignSlice(params){
    return http.post(`${resquest}/api/department/assignSlice`,params)
}
// 获取限额配置
export function quotaAssignSlice(params){
    return http.post(`${resquest}/api/adminConfig/assignConfig`,params)
}
// 修改获取限额配置
export function quotaAssignSliceEdit(params){
    return http.post(`${resquest}/api/adminConfig/editAssignConfig`,params)
}
// 获取外呼配置
export function outboundConfig(params){
    return http.post(`${resquest}/api/config/outboundConfig`,params)
}
// 修改外呼配置
export function editOutBoundConfig(params){
    return http.post(`${resquest}/api/config/editOutBoundConfig`,params)
}

/*********************** 客户线索分类（自动分配V5） ****************************** */
// 线索分类列表
export function leadCateIndex(params){
    return http.post(`${resquest}/api/customerLeads/leadCateIndex`,params)
}
// 线索分类添加
export function leadCateAdd(params){
    return http.post(`${resquest}/api/customerLeads/leadCateAdd`,params)
}
// 线索分类编辑
export function leadcateEdit(params){
    return http.post(`${resquest}/api/customerLeads/leadCateEdit`,params)
}
// sku列表
export function skuIndex(params){
    return http.post(`${resquest}/api/customerLeads/skuIndex`,params)
}
// sku增加
export function skuAdd(params){
    return http.post(`${resquest}/api/customerLeads/skuAdd`,params)
}
// sku修改
export function skuEdit(params){
    return http.post(`${resquest}/api/customerLeads/skuEdit`,params)
}
// 线索分配上限
export function leadsLimit(params){
    return http.post(`${resquest}/api/customerLeads/leadsLimit`,params)
}
// // 线索分配上限(按人分配)
// export function leadsLimit(params){
//     return http.post(`${resquest}/api/customerLeads/leadsLimit`,params)
// }
// sku列表
export function adminListLead(params){
    return http.post(`${resquest}/api/customerLeads/adminList`,params)
}
// sku列表
export function bindAdminLead(params){
    return http.post(`${resquest}/api/customerLeads/bindAdmin`,params)
}
/*********************** 线索额度 ****************************** */
// 线索额度列表
export function adminQualifyLog(params){
  return http.post(`${resquest}/api/adminQualifyLog/index`,params)
}


/*********************** 财务管理 ****************************** */
// 财务-电销订单
export function financeOrder(params){
    return http.post(`${resquest}/api/order/financeOrder`,params)
}
// 财务-导出订单
export function financeDownOrder(params){
    return http.post(`${resquest}/api/order/financeDownOrder`,params)
}
// 财务-顺丰预约-获取信息
export function orderMakeInfo(params){
    return http.post(`${resquest}/api/order/orderMakeInfo`,params)
}
// 财务-顺丰预约-进行预约
export function orderMakeSend(params){
    return http.post(`${resquest}/api/order/orderMakeSend`,params)
}
/*********************** 库管管理 ****************************** */
// 库管-电销订单
export function storehouseOrder(params){
    return http.post(`${resquest}/api/order/storehouseOrder`,params)
}
// 库管-导出订单
export function storehouseDownOrder(params){
    return http.post(`${resquest}/api/order/storehouseDownOrder`,params)
}
/*********************** 商品管理 ****************************** */
// 商品列表
export function goodsList(params){
    return http.post(`${resquest}/api/goods/goodsListNew`,params)
}
// 商品新增
export function addGoods(params){
    return http.post(`${resquest}/api/goods/addGoods`,params)
}
// 商品修改
export function editGoods(params){
    return http.post(`${resquest}/api/goods/updateGoods`,params)
}
// 商品修改状态
export function updateGoodsStatus(params){
    return http.post(`${resquest}api/goods/updateGoodsStatus`,params)
}
// 单品同步万里牛
export function syncGoodsHupun(params){
    return http.post(`${resquest}/api/goods/syncGoodsHupun`,params)
}
// 获取商品管理后台
export function getGoodsManageUrl(params){
    return http.post(`${resquest}/api/goods/getGoodsManageUrl`,params)
}
// 商品新增审批
export function addExamineGoods(params){
    return http.post(`${resquest}/api/work/addExamineGoods`,params)
}
// 商品审批列表
export function examineGoods(params){
    return http.post(`${resquest}/api/work/examineGoods`,params)
}
// 商品审批详情
export function examineGoodsDel(params){
    return http.post(`${resquest}/api/work/getExamineGoods`,params)
}
// 商品审批操作节点
export function handleExamineGoods(params){
    return http.post(`${resquest}/api/work/handleExamineGoods`,params)
}
// 商品审批流程撤回
export function recallExamineGoods(params){
    return http.post(`${resquest}/api/work/recallExamineGoods`,params)
}
// 商品获取层级
export function shopLevel(params){
    return http.post(`${resquest}/api/admin/getShopLevel`,params)
}
/*********************** 优惠券管理 ****************************** */
// 获取优惠券列表
export function couponList(params){
    return http.post(`${resquest}/api/goods/couponList`,params)
}
// 优惠券添加
export function addCoupon(params){
    return http.post(`${resquest}/api/goods/addCoupon`,params)
}
// 优惠券修改状态
export function updateCouponStatus(params){
    return http.post(`${resquest}/api/goods/updateCouponStatus`,params)
}
// 修改优惠券使用人
export function upCouponAdmin(params){
    return http.post(`${resquest}/api/goods/upCouponAdmin`,params)
}

/*********************** 店铺管理 ****************************** */
// 平台列表
export function shopTypeoptions(params){
    return http.post(`${resquest}/api/index/index`,params)
}
// 商品列表--仅用作搜索使用
export function goodsSearchList(params){
    return http.post(`${resquest}/api/goods/goodsSearchList`,params)
}
// 店铺列表
export function storeList(params){
    return http.post(`${resquest}/api/shop/shopList`,params)
}
// 店铺新增
export function storeCreate(params){
    return http.post(`${resquest}/api/shop/shopAdd`,params)
}
// 店铺修改
export function storeUpdate(params){
    return http.post(`${resquest}/api/shop/shopSave`,params)
}
// 店铺状态修改
export function storeStatus(params){
    return http.post(`${resquest}/api/shop/shopStatusSave`,params)
}
/*********************** 品牌管理 ****************************** */
// 品牌列表
export function brandList(params){
    return http.post(`${resquest}/api/brand/getBrandList`,params)
}
// 添加品牌
export function addBrand(params){
    return http.post(`${resquest}/api/brand/addBrand`,params)
}
// 公司关联品牌
export function relateCompanyToBrand(params){
    return http.post(`${resquest}/api/relate/relateCompanyToBrand`,params)
}
// 平台关联品牌
export function relatePlatformToBrand(params){
    return http.post(`${resquest}/api/relate/relatePlatformToBrand`,params)
}
// 平台列表
export function platformList(params){
    return http.post(`${resquest}/api/platform/platformIndex`,params)
}
/*********************** 企业微信 ****************************** */
// 企业微信欢迎语列表
export function welcomeMsgList(params){
    return http.post(`${resquest}/api/wecome/welcomeMsgList`,params)
}
// 添加/编辑企业微信欢迎语
export function setWelcomeMsg(params){
    return http.post(`${resquest}/api/wecome/setWelcomeMsg`,params)
}
// 查询包裹卡列表
export function packageCardList(params){
    return http.post(`${resquest}/api/wecome/packageCardList`,params)
}
// 查询包裹卡列表-企业微信配置项
export function packageCardType(params){
    return http.post(`${resquest}/api/wecome/getPackageCardType`,params)
}
//  添加/编辑包裹卡用户池
export function updatePackageCardUser(params){
    return http.post(`${resquest}/api/wecome/updatePackageCardUser`,params)
}
// 企业微信素材库列表
export function wecomeMaterialList(params){
  return http.post(`${resquest}/api/wecome/getWecomeMaterial`,params)
}
// 添加/编辑企业微信素材库
export function addWecomeMaterial(params){
  return http.post(`${resquest}/api/wecome/addWecomeMaterial`,params)
}
/*********************** 销售看板 ****************************** */
// 订单量统计—柱状图
export function orderNum(params){
    return http.post(`${resquest}/api/report/orderNum`,params)
}
// 团队看板-新
export function teamReport(params){
    return http.post(`${resquest}/api/report/teamReport`,params)
}
// 团队看板-新–导出
export function teamReportExport(params){
    return http.post(`${resquest}/api/report/teamExport`,params)
}
// 话务报表
export function trafficStatement(params){
    return http.post(`${resquest}/api/report/traffic`,params)
}
// 话务报表导出
export function trafficExport(params){
    return http.post(`${resquest}/api/report/trafficExport`,params)
}
// 数据总览
export function totalStatement(params){
    return http.post(`${resquest}/api/report/total`,params)
}
// 数据总览导出
export function totalStatementExport(params){
    return http.post(`${resquest}/api/report/totalExport`,params)
}
// 统计看板
export function statisticsStatement(params){
    return http.post(`${resquest}/api/report/statistics`,params)
}
// 统计看板导出
export function statisticsExport(params){
    return http.post(`${resquest}/api/report/statisticsExport`,params)
}
// 微信统计
export function wecomStatement(params){
    return http.post(`${resquest}/api/report/wecom`,params)
}
// 微信统计导出
export function wecomExport(params){
    return http.post(`${resquest}/api/report/wecomExport`,params)
}
// 同步数据
export function synReport(params){
    return http.post(`${resquest}/api/report/synReport`,params)
}
// 排行统计
export function ranking(params){
    return http.post(`${resquest}/api/report/ranking`,params)
}
// 趋势报表
export function trend(params){
    return http.post(`${resquest}/api/report/trend`,params)
}
//任务报表
export function taskSaleList(params){
    return http.post(`${resquest}/api/reportOrder/endList`,params)
}
//任务报表-任务确认
export function endconfirm(params){
    return http.post(`${resquest}/api/reportOrder/endConfirm`,params)
}
//任务报表导出
export function endListExport(params){
    return http.post(`${resquest}/api/reportOrder/endListExport`,params)
}
export function taskSaleCreate(params){
    return http.post(`${resquest}/api/reportOrder/endCreate`,params)
}
//提成报表
export function financeList(params){
    return http.post(`${resquest}/api/reportOrder/finance`,params)
}
//提成报表导出
export function financeExport(params){
    return http.post(`${resquest}/api/reportOrder/financeExport`,params)
}
export function financeDetailExport(params){
    return http.post(`${resquest}/api/reportOrder/financeDetailExport`,params)
}
// 商品销售报表
export function goodsSaleList(params){
    return http.post(`${resquest}/api/reportOrder/sku`,params)
}
// 年龄阶段统计
export function ageSaleList(params){
    return http.post(`${resquest}/api/reportOrder/age`,params)
}
// 商品销售报表
export function areaSaleList(params){
    return http.post(`${resquest}/api/reportOrder/area`,params)
}
// 总览统计待废弃
export function shopSaleListold(params){
    return http.post(`${resquest}/api/report/shop`,params)
}
// 总览统计
// export function shopSaleList(params){
//     return http.post(`${resquest}/api/report/overView`,params)
// }
export function shopSaleList(params){
    return http.post(`${resquest}/api/report/overView3`,params)
}

// 总览统计导出
// export function shopSaleExport(params){
//     return http.post(`${resquest}/api/report/shopExport`,params)
// }
export function shopSaleExport(params){
    return http.post(`${resquest}/api/report/overViewExport3`,params)
}
/*********************** 发票管理 ****************************** */
// 发票列表
export function invoiceList(params){
    return http.post(`${resquest}/api/invoice/index`,params)
}
// 发票申请
export function invoiceApply(params){
    return http.post(`${resquest}/api/invoice/apply`,params)
}
// 发票申请详情
export function examineinvoiceDel(params){
    return http.post(`${resquest}/api/invoice/getExamine`,params)
}
// 发票审核
// export function invoiceAudit(params){
//     return http.post(`${resquest}/api/invoice/examine`,params)
// }
export function invoiceAudit(params){
    return http.post(`${resquest}/api/invoice/handleExamine`,params)
}
// 发票流程撤回
export function examineinvoicerecall(params){
    return http.post(`${resquest}/api/invoice/recallExamine`,params)
}

/*********************** 日志管理 ****************************** */
// 订单日志
export function orderJournal(params){
    return http.post(`${resquest}/api/adminLog/order`,params)
}
// 订单日志
export function orderJournalNew(params){
    return http.post(`${resquest}/api/adminLog/orderNew`,params)
}
// 脱敏日志
export function customerViewLog(params){
    return http.post(`${resquest}/api/adminLog/customerViewLog`,params)
}
// 脱敏日志详情
export function customerViewDetailLog(params){
    return http.post(`${resquest}/api/adminLog/customerViewDetailLog`,params)
}
// 导出日志
export function downLog(params){
    return http.post(`${resquest}/api/adminLog/downLog`,params)
}
// 订单日志类型
export function orderTypeList(params){
    return http.post(`${resquest}/api/adminLog/orderTypeList`,params)
}
// 商品日志类型
export function goodsTypeList(params){
    return http.post(`${resquest}/api/adminLog/goodsTypeList`,params)
}
// 商品日志
export function goodsLog(params){
    return http.post(`${resquest}/api/adminLog/goodsLog`,params)
}

/*********************** 站内信 ****************************** */
// 获取未读数量
export function mailUnreadMessageCount(params){
    return http.post(`${resquest}/api/mail/mailUnreadMessageCount`,params)
}
// 站内信列表
// export function mailMessageList(params){
//     return http.post(`${resquest}/api/mail/mailMessageList`,params)
// }
export function mailMessageList(params){
    return http.post(`${resquest}/api/mail/mailMessageListB`,params)
}
// 查看站内信信息
export function getMailMessage(params){
    return http.post(`${resquest}/api/mail/getMailMessage`,params)
}
// 一键已读
export function oneClickRead(params){
    return http.post(`${resquest}/api/mail/oneClickRead`,params)
}
/*********************** 激励语 ****************************** */
// 激励语列表
export function motivationalLanguageList(params){
    return http.post(`${resquest}/api/trafficInspiring/index`,params)
}
// 激励语添加
export function motivationalLanguageAdd(params){
    return http.post(`${resquest}/api/trafficInspiring/create`,params)
}
// 激励语删除
export function motivationalLanguageDel(params){
    return http.post(`${resquest}/api/trafficInspiring/delete`,params)
}
/*********************** 活码管理 ****************************** */
// 活码配置列表
export function wecomLiveCodeList(params){
    return http.post(`${resquest}/api/wecome/getWecomLiveCodeList`,params)
}
// 编辑活码销售
export function saveWecomLiveCodeUser(params){
    return http.post(`${resquest}/api/wecome/saveWecomLiveCodeUser`,params)
}
/*********************** 排班管理 ****************************** */
// 更改排班
export function contextOwnerList(params){
    return http.post(`${resquest}/api/user/scheduleList`,params)
}
// 获取排班列表
export function contextOwnerChange(params){
    return http.post(`${resquest}/api/user/updateUserSchedule`,params)
}
// 获取排班状态信息
export function contextOwnerStatus(params){
    return http.post(`${resquest}/api/user/getScheduleStatus`,params)
}
// 钉钉进行登录/绑定 url
export function dingTalkUrl(params){
    return http.post(`${resquest}/api/ding/getDingTalkUrl`,params)
}
// 钉钉登录/绑定
export function dingTalkToUserInfo(params){
    return http.post(`${resquest}/api/dingtalk/dingTalkToUserInfo`,params)
}
// 上线领取客户（点击上线后调用）
export function onLineToGet(params){
    return http.post(`${resquest}/api/customer/onLineToGet`,params)
}
/*********************** 钉钉打卡 ****************************** */
// 获取未读数量
export function handDingTalkWork(params){
    return http.post(`${resquest}/api/user/handDingTalkWork`,params)
}
/*********************** CRM设置管理 ****************************** */
// 成交来源
export function tradeSource(params){
    return http.post(`${resquest}/api/order/getTradeSource`,params)
}
// 添加成交来源
export function addTradeSource(params){
    return http.post(`${resquest}/api/order/addTradeSource`,params)
}
// 修改成交来源
export function saveTradeSource(params){
    return http.post(`${resquest}/api/order/saveTradeSource`,params)
}

/*********************** 报表 ****************************** */
// 数据总览
export function overViewStatement(params){
    return http.post(`${resquest}/api/reportSecond/overView`,params)
}
export function overViewStatementB(params){
  return http.post(`${resquest}/api/reportSecond/overViewB`,params)
}
// 数据总览导出
export function overViewExport(params){
    return http.post(`${resquest}/api/reportSecond/overViewExport`,params)
}
export function overViewExportB(params){
  return http.post(`${resquest}/api/reportSecond/overViewExportB`,params)
}
// 业绩分析
export function performanceAnalysis(params){
    return http.post(`${resquest}/api/reportSecond/analysis`,params)
}
// 团队分析
export function performanceAnalysisExport(params){
    return http.post(`${resquest}/api/reportSecond/analysisExport`,params)
}
// 团队分析
export function teamAnalysis(params){
    return http.post(`${resquest}/api/reportSecond/teamAnalysis`,params)
}
// 团队分析导出
export function teamAnalysisExport(params){
    return http.post(`${resquest}/api/reportSecond/teamAnalysisExport`,params)
}
// 兑奖报表
export function prizeStatement(params){
    return http.post(`${resquest}/api/reportOrder/package`,params)
}
// 包裹卡列表
export function reportPackageAnalyse(params){
    return http.post(`${resquest}/api/reportPackageAnalyse/getReportPackageAnalyse`,params)
}
// 添加包裹卡数据
export function addReportPackageAnalyse(params){
    return http.post(`${resquest}/api/reportPackageAnalyse/addReportPackageAnalyse`,params)
}
// 获取包裹卡承接人信息
export function packageAnalyseUser(params){
    return http.post(`${resquest}/api/reportPackageAnalyse/getPackageAnalyseUser`,params)
}
// 包裹卡分析导出
export function downReportPackageAnalyse(params){
    return http.post(`${resquest}/api/reportPackageAnalyse/downReportPackageAnalyse`,params)
}


/**
 * 通用文件上传
 */
export const uploadFiles = resquest + '/api/upload/oss'; //文件上传







// WEBPACK FOOTER //
// ./src/api/api.js